import React, { useMemo } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import * as yup from "yup";
import {
  CForm,
  CDropDown,
  CRadio,
  CButton,
  P
} from "@appcues/component-library";
import { JOB_DROPDOWN_OPTIONS } from "constants/inviteModal";
import Modal from "components/Common/UI/Modal/Modal";

const InviteModal = ({ enableEditorRole, onSubmit, onClose }) => {
  const permisisonOptions = useMemo(
    () => [
      {
        label: "Admin",
        value: "ACCOUNT_ADMIN",
        caption: "Create, edit, publish, and manage account"
      },
      {
        label: "Publisher",
        value: "PUBLISHER",
        caption: "Create, edit, and publish"
      },
      ...(enableEditorRole
        ? {
            label: "Editor",
            value: "EDITOR",
            caption: "Create and edit (cannot publish)"
          }
        : [])
    ],
    [enableEditorRole]
  );

  const handleSubmit = ({
    firstName,
    lastName,
    emailAddress: email,
    job,
    role
  }) =>
    onSubmit({
      name: `${firstName} ${lastName}`,
      email,
      job,
      role
    });

  return (
    <Modal type="full" title="Invite a teammate" onClose={onClose}>
      <StyledForm
        onSubmit={handleSubmit}
        initialValues={{
          firstName: "",
          lastName: "",
          emailAddress: "",
          job: "",
          role: ""
        }}
        validationSchema={yup.object().shape({
          job: yup.string().required("Required"),
          lastName: yup.string().required("Required"),
          firstName: yup.string().required("Required"),
          emailAddress: yup
            .string()
            .email("Email must be a valid address.")
            .required("Required"),
          role: yup.string().required("Required")
        })}
      >
        <Modal.Content paddingX={20}>
          <P>We'll send them an email invite to your Appcues account.</P>
          <CForm.Row>
            <CForm.Field
              label="First Name"
              placeholder="Enter first name"
              name="firstName"
            />
            <CForm.Field
              label="Last Name"
              placeholder="Enter last name"
              name="lastName"
            />
          </CForm.Row>
          <CForm.Row>
            <CForm.Field
              label="Email"
              placeholder="Enter email address"
              name="emailAddress"
            />
            <CForm.Field label="Job" name="job">
              <CDropDown
                options={JOB_DROPDOWN_OPTIONS}
                placeholder="--- Please select ---"
              />
            </CForm.Field>
          </CForm.Row>
          <CForm.Field label="Permissions" name="role">
            <CRadio.Group>
              {permisisonOptions.map(({ label, value, caption }) => (
                <CRadio
                  key={value}
                  label={label}
                  value={value}
                  caption={caption}
                />
              ))}
            </CRadio.Group>
          </CForm.Field>
        </Modal.Content>
        <Modal.Footer>
          <CButton onClick={onClose}>Cancel</CButton>
          <CForm.SubmitButton type="primary" disabledUntilDirty={false}>
            Invite
          </CForm.SubmitButton>
        </Modal.Footer>
      </StyledForm>
    </Modal>
  );
};

const StyledForm = styled(CForm)`
  height: 100%;
  width: 100%;
  main {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    display: block;
  }
`;

InviteModal.propTypes = {
  enableEditorRole: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

export default InviteModal;
